import React from "react";
import { Container, Row, Col, Table, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import related1 from "../Assets/Image/related1.jpg";
import related2 from "../Assets/Image/related2.jpg";
import related3 from "../Assets/Image/related3.jpg";
import related4 from "../Assets/Image/related4.jpg";
import { Helmet } from "react-helmet";

const relatedProducts = [
  { name: "Fish Plates for Busbar Trunking", image: related1 },
  { name: "Sub Assemblies - Busbar Trunking", image: related2 },
  { name: "Stamped Parts - Non Ferrous", image: related3 },
  { name: "Resistance Welded Flexibles", image: related4 },
];

const FeederLengthForBTS = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Feeder Length For BTS | Delta Engineering</title>
        <meta
          name="description"
          content="High-performance feeder connectors for telecom BTS applications. Designed for low attenuation, durability, and corrosion resistance with custom lengths and configurations."
        />
        <meta
          name="keywords"
          content="Feeder Length for BTS, RF Feeder Cable, Telecom BTS Connectors, Coaxial Cable BTS, N-Type Feeder Cable, DIN Feeder Cable, BTS RF Cable, Mobile Tower Cable"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Feeder Length For BTS" />
        <meta
          property="og:description"
          content="Engineered feeder cables for Base Transceiver Stations with high conductivity, low signal loss, and weather resistance. Custom lengths available for telecom projects."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/feeder-length-for-bts"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/feeder-length-for-bts.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Feeder Length For BTS" />
        <meta
          name="twitter:description"
          content="Custom RF feeder cables for telecom BTS systems. High conductivity, low attenuation, and weatherproof performance for reliable signal transmission."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/feeder-length-for-bts.jpg"
        />
      </Helmet>
      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">
          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <span className="blue-text"> Feeder Length</span>{" "}
                <span className="white-text"> For BTS</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                Enhanced surface finishes for corrosion resistance and long-term
                conductivity performance.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-5 pt-3" style={{ position: "relative" }}>
        <Container>
          <Button onClick={() => navigate("/ourproducts")} className="back-btn">
            <IoMdArrowRoundBack className="back-icon" />
            Back
          </Button>
          <Row className="text-center mb-4">
            <Col>
              <h3 className="fw-bold section-title">
                Feeder Length For BTS <span className="title-underline"></span>
              </h3>
              <p className="text-muted mb-4">
                High-performance feeder connectors specifically engineered for
                telecom BTS applications, ensuring signal integrity, durability,
                and low attenuation in every environment.
              </p>
            </Col>
          </Row>

          <h4 className="mt-5">Key Features</h4>
          <ul>
            <li>High conductivity with minimal electrical resistance</li>
            <li>Low signal attenuation for optimal RF performance</li>
            <li>Durable against weather, corrosion, and vibrations</li>
            <li>Custom lengths and configurations as per site needs</li>
            <li>Available in flexible or rigid constructions</li>
          </ul>

          <h4 className="mt-5">Technical Specifications</h4>
          <Table striped bordered responsive>
            <tbody>
              <tr>
                <td>Product Type</td>
                <td>RF Feeder Cable for BTS</td>
              </tr>
              <tr>
                <td>Application</td>
                <td>Mobile Tower (Base Transceiver Station) Connections</td>
              </tr>
              <tr>
                <td>Cable Type</td>
                <td>Coaxial (typically 1/2" or 7/8" Corrugated)</td>
              </tr>
              <tr>
                <td>Frequency Range</td>
                <td>0 – 3 GHz</td>
              </tr>
              <tr>
                <td>Impedance</td>
                <td>50 Ohms</td>
              </tr>
              <tr>
                <td>Connector Types</td>
                <td>
                  N-Type Male, 7/16 DIN, customized as per site requirement
                </td>
              </tr>
              <tr>
                <td>Length</td>
                <td>Customized (1m – 100m or as required)</td>
              </tr>
              <tr>
                <td>Jacket Material</td>
                <td>UV-resistant PE (Polyethylene)</td>
              </tr>
              <tr>
                <td>Shielding</td>
                <td>Aluminum Foil + Braided Copper</td>
              </tr>
              <tr>
                <td>Operating Temperature</td>
                <td>-40°C to +85°C</td>
              </tr>
              <tr>
                <td>VSWR (Voltage Standing Wave Ratio)</td>
                <td>≤ 1.2:1</td>
              </tr>
              <tr>
                <td>Attenuation</td>
                <td>Low loss per meter (depends on cable type)</td>
              </tr>
              <tr>
                <td>Weatherproofing</td>
                <td>Yes (suitable for outdoor installations)</td>
              </tr>
              <tr>
                <td>Certification</td>
                <td>RoHS, ISO, Telecom-compliant</td>
              </tr>
            </tbody>
          </Table>
          <h4 className="mt-5">Applications</h4>
          <ul>
            <li>Base Transceiver Stations (BTS)</li>
            <li>Remote Radio Units (RRU)</li>
            <li>Distributed Antenna Systems (DAS)</li>
            <li>Grounding & Bonding in outdoor enclosures</li>
            <li>Battery Backup & Power Supply Systems</li>
          </ul>

          <h4 className="mt-5 mb-4">Related Products</h4>
          <Row>
            {relatedProducts.map((product, index) => (
              <Col md={3} sm={6} xs={12} className="mb-4" key={index}>
                <Card className="h-100 shadow-sm border-0">
                  <Card.Img
                    variant="top"
                    src={product.image}
                    alt={product.name}
                    style={{ height: "180px", objectFit: "cover" }}
                  />
                  <Card.Body className="text-center">
                    <Card.Title className="fs-6">{product.name}</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default FeederLengthForBTS;
